import { convertToHex } from '../validation/colorUtils';

export const formatChatMessage = (text: string): string => {
  // Remove double asterisks and replace with proper formatting
  const formattedText = text
    .split('\n')
    .map(line => {
      // Handle titles
      if (line.startsWith('# ')) {
        return line;
      }
      // Handle lists
      if (line.startsWith('• ')) {
        return line;
      }
      // Handle bold text without asterisks
      return line.replace(/\*\*(.*?)\*\*/g, '$1');
    })
    .join('\n');

  return formattedText;
};

export const getInitialGreeting = (userName: string | null | undefined): string => {
  const hour = new Date().getHours();
  let greeting = '';

  if (hour < 12) {
    greeting = 'Bonjour';
  } else if (hour < 18) {
    greeting = 'Bon après-midi';
  } else {
    greeting = 'Bonsoir';
  }

  const displayName = userName?.split('@')[0] || 'cher utilisateur';

  return `${greeting} ${displayName} ! 👋\n\nJe suis Benjamin, votre assistant Shopiweb Manager. Je peux vous aider avec :\n\n• L'activation et la gestion de vos licences\n• Le support technique\n• Les informations sur nos offres\n• La documentation et les guides\n\nComment puis-je vous aider aujourd'hui ?`;
};